export default __webpack_public_path__ + "static/media/baton_bronze.d453cabe.jpg";